import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, createSlots as _createSlots } from "vue";
var _hoisted_1 = {
  class: "account"
};
var _hoisted_2 = {
  class: "account-body"
};
var _hoisted_3 = {
  class: "account-body-center"
};
var _hoisted_4 = {
  key: 0,
  class: "account-body-center-li"
};
var _hoisted_5 = {
  class: "account-body-center-li-left"
};
var _hoisted_6 = {
  key: 1,
  class: "account-body-center-li"
};
var _hoisted_7 = {
  class: "account-body-center-li-left"
};
var _hoisted_8 = {
  class: "account-body-center-li"
};
var _hoisted_9 = {
  class: "account-body-center-li-left"
};
var _hoisted_10 = {
  class: "account-body-center-li"
};
var _hoisted_11 = {
  class: "account-body-center-li-left"
};
var _hoisted_12 = {
  key: 0,
  class: "wechat-info"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  class: "nickname"
};
var _hoisted_15 = {
  class: "account-body-center-li"
};
var _hoisted_16 = {
  class: "account-body-center-li-left"
};
var _hoisted_17 = {
  class: "account-body-center-li"
};
var _hoisted_18 = {
  class: "account-body-center-li-left"
};
var _hoisted_19 = {
  class: "account-body-center-li"
};
var _hoisted_20 = {
  key: 2,
  class: "account-body-center-li"
};
var _hoisted_21 = {
  class: "account-body-center-li-left"
};
var _hoisted_22 = {
  class: "account-body-center-li"
};
var _hoisted_23 = {
  class: "account-body-center-li-left"
};
var _hoisted_24 = {
  key: 3,
  class: "account-body-center-li",
  style: {
    "border": "none"
  }
};
var _hoisted_25 = {
  class: "account-body-center-li",
  style: {
    "border": "none",
    "display": "block"
  }
};
var _hoisted_26 = {
  class: "maneger-list"
};
var _hoisted_27 = {
  key: 0,
  class: "wxbind"
};
var _hoisted_28 = ["src"];
var _hoisted_29 = {
  key: 1,
  style: {
    "color": "#999"
  }
};
var _hoisted_30 = {
  key: 1,
  style: {
    "color": "#999"
  }
};
var _hoisted_31 = {
  key: 1,
  style: {
    "color": "#999"
  }
};
var _hoisted_32 = {
  key: 1,
  style: {
    "color": "#999"
  }
};
var _hoisted_33 = {
  key: 0,
  style: {
    "padding-right": "16px"
  }
};
var _hoisted_34 = {
  style: {
    "width": "300px"
  }
};
var _hoisted_35 = {
  key: 0,
  class: "green"
};
var _hoisted_36 = {
  key: 1,
  class: "red"
};
var _hoisted_37 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end"
  }
};
var _hoisted_38 = {
  key: 1,
  style: {
    "color": "#999"
  }
};
var _hoisted_39 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end"
  }
};
var _hoisted_40 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end"
  }
};
var _hoisted_41 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
import { ref, onMounted } from 'vue';
import { getStore, setStore, removeStore, clearStore } from '@/util/store';
import qs from 'querystring';
import { isMobile, isEmail, validateName, validateUserName, validatePwd } from '@/util/validate';
import { toLogin, env_name } from '@/util/util';
import { useRoute, useRouter } from 'vue-router';
import { getUserInfo, getUserToken, getUpdateInfo, getSendSmsCodes, getVeriSmsCode, getSendEmailCode, getVeriEmailCode, getEditPerson, getUserCheckPwd, getCancleledReason, getCancleled, getRecallCancleled, getSignOut, getCommonModeration, unbindWechat, bindWechat, getManagerContacts } from '@/api/user.js';
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { Encrypt } from '@/util/handelEncryptedData.js';
import navLeft from '@/components/navLeft';
import unbindPhoneDialog from './widgets/unbindPhoneDialog.vue';
export default {
  __name: 'AccountInfo',
  setup: function setup(__props) {
    var accessInfo = getStore({
      name: 'accessInfo'
    }); // 获取accessInfo
    var userInfo = ref(getStore({
      name: 'userInfo'
    })); // 获取userInfo

    var unbindPhoneShow = ref(false);
    var memberTypesObj = {
      manager: '管理',
      teacher: '教师',
      student: '学生'
    };
    var route = useRoute();
    var router = useRouter();
    var sendOut = ref(0); //发送短信倒计时
    var passwordCode = ref(''); // 短信验证码
    var timer = null;
    var systemAutoUsernameFlag = ref(accessInfo.systemAutoUsernameFlag === 1);
    var nickname = ref(accessInfo.nickname);
    var nicknameVisible = ref(false);
    var nicknameOld = ref(accessInfo.nickname);
    var nicknameHandleCancel = function nicknameHandleCancel() {
      nicknameOld.value = nickname.value;
    };
    var phone = ref(accessInfo.phone);
    var phoneVisible = ref(false);
    var phoneOld = ref('');
    var phoneHandleCancel = function phoneHandleCancel() {
      phoneOld.value = '';
      passwordCode.value = '';
    };
    var wechat = ref(userInfo.value.wxOpenid);
    var hosts = window.location.host.split('.').reverse();
    var host = hosts.length > 1 ? "".concat(hosts[1], ".").concat(hosts[0]) : 'zhixuehuijiao.cn';
    var wxbindCodeUri = ref("//".concat(env_name, "wx-qrcodescan.").concat(host, "/qrcode?business=202"));
    var wxbindDialog = ref(false);
    var toBindWechat = function toBindWechat() {
      if (userInfo.value.wxOpenid) {
        var DialogInstance = DialogPlugin.confirm({
          theme: 'warning',
          header: '确定要解除绑定吗',
          cancelBtn: '取消',
          closeBtn: null,
          closeOnEscKeydown: false,
          closeOnOverlayClick: false,
          confirmBtn: '确认',
          onConfirm: function onConfirm() {
            var data = new FormData();
            data.append('state', 'WX');
            unbindWechat(data).then(function (res) {
              if (res.data.code === 0) {
                MessagePlugin.success('微信解绑成功');
                getUserInfo(userInfo.value.id).then(function (res) {
                  if (res.data.code === 0) {
                    var curUserInfo = res.data.data;
                    setStore({
                      name: 'userInfo',
                      content: curUserInfo
                    });
                    userInfo.value = getStore({
                      name: 'userInfo'
                    });
                    wechat.value = null;
                  }
                });
              } else {
                MessagePlugin.error("\u5FAE\u4FE1\u89E3\u7ED1\u5931\u8D25(".concat(res.data.msg, ")"));
              }
            }).finally(function () {
              DialogInstance.destroy();
            });
          }
        });
      } else {
        wxbindDialog.value = true;
      }
    };
    var checkNeedBindWX = function checkNeedBindWX() {};
    var email = ref(accessInfo.email);
    var emailVisible = ref(false);
    var emailOld = ref('');
    var emailHandleCancel = function emailHandleCancel() {
      emailOld.value = '';
      passwordCode.value = '';
    };
    var username = ref(accessInfo.username);
    var usernameVisible = ref(false);
    var usernameOld = ref('');
    var usernameHandleCancel = function usernameHandleCancel() {
      usernameOld.value = '';
      password.value = '';
      passwordOld.value = '';
    };
    var password = ref('');
    var passwordVisible = ref(false);
    var passwordOld = ref('');
    var passwordHandleCancel = function passwordHandleCancel() {
      password.value = '';
      passwordOld.value = '';
    };

    // 引导第一步第二步逻辑块
    var stepOnenickname = ref('');
    var stepOneVisible = ref(false);
    var stepTwoUsername = ref('');
    var stepTwoPassword = ref('');
    var stepTwoPasswordOld = ref('');
    var stepTwoVisible = ref(false);
    if (accessInfo.accountType === 2 && accessInfo.abnormalCode === '006') {
      stepOneVisible.value = true;
    }
    var stepOneHandleCancel = function stepOneHandleCancel() {
      accessInfo = _objectSpread(_objectSpread({}, accessInfo), {}, {
        abnormalCode: null
      });
      setStore({
        name: 'accessInfo',
        content: accessInfo
      });
      stepOneVisible.value = false;
    };
    var stepOneHandleOk = function stepOneHandleOk() {
      if (validateName(stepOnenickname.value)) {
        getCommonModeration({
          eventType: 'nickname',
          text: stepOnenickname.value
        }).then(function (res) {
          if (res.data.code === 0 && res.data.data.suggestion === 'pass') {
            getEditPerson({
              userId: accessInfo.user_id,
              nickname: stepOnenickname.value
            }).then(function (res) {
              if (res.data.code === 0) {
                MessagePlugin.closeAll();
                MessagePlugin.success('昵称保存成功');
                nickname.value = stepOnenickname.value;
                nicknameOld.value = stepOnenickname.value;
                accessInfo = _objectSpread(_objectSpread({}, accessInfo), {}, {
                  nickname: nickname.value,
                  abnormalCode: null
                });
                setStore({
                  name: 'accessInfo',
                  content: accessInfo
                });
                stepOneVisible.value = false;
                stepTwoVisible.value = true;
              }
            });
          } else {
            MessagePlugin.closeAll();
            MessagePlugin.error('昵称包含法律法规或监管政策所限制的敏感内容，请修改后再发布。');
          }
        });
      } else {
        MessagePlugin.closeAll();
        MessagePlugin.warning('请输入汉字、数字、英文字母和_，不支持其他字符');
      }
    };
    var stepTwoHandleOk = function stepTwoHandleOk() {
      if (!validateUserName(stepTwoUsername.value)) {
        MessagePlugin.closeAll();
        MessagePlugin.warning('请输入6-20个字符，支持英文字母、数字和下划线的用户名');
      } else if (!validatePwd(stepTwoPassword.value)) {
        MessagePlugin.closeAll();
        MessagePlugin.warning('请输入8-16位数字大小写字母或符号2种以上组合密码');
      } else if (stepTwoPassword.value !== stepTwoPasswordOld.value) {
        MessagePlugin.closeAll();
        MessagePlugin.warning('二次密码输入不一致');
      } else {
        getEditPerson({
          userId: accessInfo.user_id,
          username: stepTwoUsername.value,
          password: Encrypt(stepTwoPassword.value)
        }).then(function (res) {
          username.value = stepTwoUsername.value;
          systemAutoUsernameFlag.value = false;
          removeStore({
            name: 'access_token'
          });
          getUserToken({
            userName: username.value,
            password: Encrypt(stepTwoPassword.value)
          }).then(function (res) {
            setStore({
              name: 'access_token',
              content: res.data.access_token
            });
            accessInfo = _objectSpread(_objectSpread({}, accessInfo), {}, {
              username: username.value,
              systemAutoUsernameFlag: 0,
              access_token: res.data.access_token
            });
            setStore({
              name: 'accessInfo',
              content: accessInfo
            });
            stepTwoVisible.value = false;
          });
        });
      }
    };

    //单独修改每一项逻辑块
    var openModalVisible = ref(false); // Step1-选择验证方式
    var openModalIndex = ref(0); // 记录点击的是哪个按钮 0默认 1手机 2邮箱 3用户名 4密码
    var openModalVisibles = ref(false); // Step2-身份验证
    var openModalIndexs = ref(0); // 记录怎么验证验证方法 0默认 1帐号+密码 2手机+验证码 3邮箱+验证码
    var openModalPassword = ref('');
    var openModal = function openModal(index) {
      openModalIndex.value = index;
      openModalVisible.value = true;
    };
    var openModalClick = function openModalClick(index) {
      openModalVisible.value = false;
      openModalVisibles.value = true;
      openModalIndexs.value = index;
      openModalPassword.value = '';
    };
    var openModalCancel = function openModalCancel() {
      openModalVisible.value = true;
    };
    var openModalOk = function openModalOk() {
      if (openModalIndexs.value === 1) {
        if (!openModalPassword.value) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入密码');
        } else {
          getUserCheckPwd({
            userId: accessInfo.user_id,
            content: username.value,
            password: Encrypt(openModalPassword.value)
          }).then(function (res) {
            if (res.data.code === 0) {
              openModalPassword.value = '';
              openModalVisibles.value = false;
              if (openModalIndex.value === 1) {
                phoneVisible.value = true;
              } else if (openModalIndex.value === 2) {
                emailVisible.value = true;
              } else if (openModalIndex.value === 3) {
                usernameVisible.value = true;
              } else if (openModalIndex.value === 4) {
                systemAutoUsernameFlag.value ? usernameVisible.value = true : passwordVisible.value = true;
              }
            }
          });
        }
      } else if (openModalIndexs.value === 2) {
        if (!openModalPassword.value) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入验证码');
        } else {
          getVeriSmsCode(phone.value, 3, openModalPassword.value).then(function (res) {
            if (res.data.code === 0) {
              openModalPassword.value = '';
              openModalVisibles.value = false;
              clearInterval(timer);
              sendOut.value = 0;
              if (openModalIndex.value === 1) {
                phoneVisible.value = true;
              } else if (openModalIndex.value === 2) {
                emailVisible.value = true;
              } else if (openModalIndex.value === 3) {
                usernameVisible.value = true;
              } else if (openModalIndex.value === 4) {
                systemAutoUsernameFlag.value ? usernameVisible.value = true : passwordVisible.value = true;
              }
            }
          });
        }
      } else if (openModalIndexs.value === 3) {
        if (!openModalPassword.value) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入验证码');
        } else {
          getVeriEmailCode(email.value, 4, openModalPassword.value).then(function (res) {
            if (res.data.code === 0) {
              openModalPassword.value = '';
              openModalVisibles.value = false;
              clearInterval(timer);
              sendOut.value = 0;
              if (openModalIndex.value === 1) {
                phoneVisible.value = true;
              } else if (openModalIndex.value === 2) {
                emailVisible.value = true;
              } else if (openModalIndex.value === 3) {
                usernameVisible.value = true;
              } else if (openModalIndex.value === 4) {
                systemAutoUsernameFlag.value ? usernameVisible.value = true : passwordVisible.value = true;
              }
            }
          });
        }
      }
    };
    var handleOk = function handleOk() {
      if (nicknameVisible.value) {
        // 修改昵称
        if (validateName(nicknameOld.value)) {
          getCommonModeration({
            eventType: 'nickname',
            text: nicknameOld.value
          }).then(function (res) {
            if (res.data.code === 0 && res.data.data.suggestion === 'pass') {
              getUpdateInfo({
                userId: accessInfo.user_id,
                type: 4,
                content: nicknameOld.value
              }).then(function (res) {
                if (res.data.code === 0) {
                  MessagePlugin.success('昵称修改成功');
                  nickname.value = nicknameOld.value;
                  accessInfo = _objectSpread(_objectSpread({}, accessInfo), {}, {
                    nickname: nickname.value
                  });
                  userInfo.value.name = nickname.value;
                  setStore({
                    name: 'accessInfo',
                    content: accessInfo
                  });
                  setStore({
                    name: 'userInfo',
                    content: userInfo.value
                  });
                  nicknameVisible.value = false;
                }
              });
            } else {
              MessagePlugin.closeAll();
              MessagePlugin.error('昵称包含法律法规或监管政策所限制的敏感内容，请修改后再发布。');
            }
          });
        } else {
          MessagePlugin.warning('请输入汉字、数字、英文字母和_，不支持其他字符');
        }
      } else if (phoneVisible.value) {
        // 修改手机号
        if (!phoneOld.value) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入手机号');
        } else if (!passwordCode.value) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入验证码');
        } else {
          getVeriSmsCode(phoneOld.value, 6, passwordCode.value).then(function (res) {
            if (res.data.code === 0) {
              getUpdateInfo({
                userId: accessInfo.user_id,
                type: 2,
                content: phoneOld.value
              }).then(function (res) {
                if (res.data.code === 0) {
                  phone.value = phoneOld.value;
                  phoneVisible.value = false;
                  MessagePlugin.success('手机号修改成功');
                  accessInfo = _objectSpread(_objectSpread({}, accessInfo), {}, {
                    phone: phone.value
                  });
                  setStore({
                    name: 'accessInfo',
                    content: accessInfo
                  });
                }
              });
            }
          });
        }
      } else if (emailVisible.value) {
        // 修改邮箱
        if (!emailOld.value) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入邮箱');
        } else if (!passwordCode.value) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入验证码');
        } else {
          getVeriEmailCode(emailOld.value, 3, passwordCode.value).then(function (res) {
            if (res.data.code === 0) {
              getUpdateInfo({
                userId: accessInfo.user_id,
                type: 3,
                content: emailOld.value
              }).then(function (res) {
                if (res.data.code === 0) {
                  email.value = emailOld.value;
                  emailVisible.value = false;
                  MessagePlugin.success('邮箱修改成功');
                  accessInfo = _objectSpread(_objectSpread({}, accessInfo), {}, {
                    email: email.value
                  });
                  setStore({
                    name: 'accessInfo',
                    content: accessInfo
                  });
                }
              });
            }
          });
        }
      } else if (usernameVisible.value) {
        // 设置用户名、密码
        if (!validateUserName(usernameOld.value)) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入6-20个字符，支持英文字母、数字和下划线的用户名');
        } else if (!validatePwd(password.value)) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入8-16位数字大小写字母或符号2种以上组合密码');
        } else if (password.value !== passwordOld.value) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('二次密码输入不一致');
        } else {
          getEditPerson({
            userId: accessInfo.user_id,
            username: usernameOld.value,
            password: Encrypt(password.value)
          }).then(function (res) {
            if (res.data.code === 0) {
              username.value = usernameOld.value;
              password.value = '';
              passwordOld.value = '';
              usernameVisible.value = false;
              MessagePlugin.success('用户名、密码设置成功');
              clearStore();
              toLogin();
            }
          });
        }
      } else if (passwordVisible.value) {
        // 修改密码
        if (!validatePwd(password.value)) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入8-16位数字大小写字母或符号2种以上组合密码');
        } else if (password.value !== passwordOld.value) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('二次密码输入不一致');
        } else {
          getUpdateInfo({
            userId: accessInfo.user_id,
            type: 1,
            content: Encrypt(password.value)
          }).then(function (res) {
            if (res.data.code === 0) {
              password.value = '';
              passwordOld.value = '';
              passwordVisible.value = false;
              MessagePlugin.success('密码修改成功');
              clearStore();
              toLogin();
            }
          });
        }
      }
    };

    // 发送验证码
    var sendOutCode = function sendOutCode(index) {
      if (index === 1) {
        if (!isMobile(phoneVisible.value ? phoneOld.value : phone.value)) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('请输入正确的手机号');
        } else {
          if (phoneVisible.value && phone.value === phoneOld.value) {
            MessagePlugin.closeAll();
            MessagePlugin.warning('新手机号和旧手机号相同');
          } else {
            getSendSmsCodes(phoneVisible.value ? phoneOld.value : phone.value, phoneVisible.value ? 6 : 3).then(function (res) {
              if (res.data.code === 0) {
                passwordCode.value = '';
                openModalPassword.value = '';
                sendOut.value = 60;
                timer = setInterval(function () {
                  sendOut.value = sendOut.value - 1;
                  if (sendOut.value === 0) {
                    clearInterval(timer);
                  }
                }, 1000);
              }
            });
          }
        }
      } else if (index === 2) {
        var msg = isEmail(emailVisible.value ? emailOld.value : email.value);
        if (!msg) {
          MessagePlugin.closeAll();
          MessagePlugin.warning('邮箱格式不正确');
        } else {
          if (emailVisible.value && email.value === emailOld.value) {
            MessagePlugin.closeAll();
            MessagePlugin.warning('新邮箱和旧邮箱相同');
          }
          getSendEmailCode(emailVisible.value ? emailOld.value : email.value, emailVisible.value ? 3 : 4).then(function (res) {
            if (res.data.code === 0) {
              passwordCode.value = '';
              openModalPassword.value = '';
              sendOut.value = 60;
              timer = setInterval(function () {
                sendOut.value = sendOut.value - 1;
                if (sendOut.value === 0) {
                  clearInterval(timer);
                }
              }, 1000);
            }
          });
        }
      } else if (index === 3) {
        getSendSmsCodes(phone.value, 5).then(function (res) {
          if (res.data.code === 0) {
            cancellationPassword.value = '';
            sendOut.value = 60;
            timer = setInterval(function () {
              sendOut.value = sendOut.value - 1;
              if (sendOut.value === 0) {
                clearInterval(timer);
              }
            }, 1000);
          }
        });
      }
    };
    var cancellationArr = ['慧学慧研帐号注销协议', '校验失败', '校验成功', '请验证您的手机号', '注销成功'];
    var cancellationVisible = ref(false); // 注销
    var cancellationIndex = ref(0); // 当前进度
    var cancellationChecked = ref(false); // 勾选同意协议
    var cancellationStyle = ref(980);
    var cancellationList = ref([]);
    var cancellationPassword = ref('');
    var cancellationStep1 = function cancellationStep1() {
      if (!cancellationChecked.value) {
        MessagePlugin.closeAll();
        MessagePlugin.warning('请阅读勾选注销协议');
      } else {
        getCancleledReason(accessInfo.user_id).then(function (res) {
          if (res.data.code === 0) {
            var onOff = true;
            res.data.data.forEach(function (item) {
              if (!item.flag) {
                onOff = false;
              }
            });
            cancellationIndex.value = onOff ? 2 : 1;
            cancellationStyle.value = 500;
            cancellationList.value = res.data.data;
          }
        });
      }
    };
    var afterClose = function afterClose() {
      cancellationIndex.value = 0;
      cancellationChecked.value = false;
      cancellationStyle.value = 980;
      cancellationPassword.value = '';
    };
    var cancellationOk = function cancellationOk() {
      if (!cancellationPassword.value) {
        MessagePlugin.closeAll();
        MessagePlugin.warning('请输入验证码');
      } else {
        getVeriSmsCode(phone.value, 5, cancellationPassword.value).then(function (res) {
          if (res.data.code === 0) {
            getCancleled(accessInfo.user_id).then(function (res) {
              if (res.data.code === 0) {
                cancellationIndex.value = 4;
              }
            });
          }
        });
      }
    };
    var cancellationOkLogin = function cancellationOkLogin() {
      cancellationVisible.value = false;
      getSignOut().then(function (res) {
        if (res.data.code === 0) {
          clearStore();
          toLogin();
        }
      });
    };
    var cancellationRevoke = function cancellationRevoke() {
      getRecallCancleled(accessInfo.user_id).then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('撤销注销申请成功');
          cancellationVisible.value = false;
        }
      });
    };
    var managerInfo = ref({});
    var getManagers = function getManagers() {
      getManagerContacts().then(function (res) {
        if (res.data.code === 0) {
          managerInfo.value = res.data.data || {};
        }
      });
    };

    // 校验并修正手机号输入内容
    var handleInput = function handleInput(value) {
      phoneOld.value = value.replace(/[^\d]/g, '');
    };
    onMounted(function () {
      getManagers();
      var _route$query = route.query,
        code = _route$query.code,
        state = _route$query.state;
      if (code && state) {
        var data = new FormData();
        data.append('state', 'WX');
        data.append('code', code);
        bindWechat(data).then(function (res) {
          if (res.data.code === 0) {
            MessagePlugin.success('微信绑定成功');
            getUserInfo(userInfo.value.id).then(function (res) {
              if (res.data.code === 0) {
                var curUserInfo = res.data.data;
                setStore({
                  name: 'userInfo',
                  content: curUserInfo
                });
                userInfo.value = getStore({
                  name: 'userInfo'
                });
                wechat = userInfo.value.wxOpenid;
                delete route.query.code;
                delete route.query.state;
                var qsstr = Object.keys(route.query).length ? "?".concat(qs.stringify(route.query)) : '';
                location.href = location.origin + location.pathname + qsstr;
              }
            });
          } else {
            MessagePlugin.error("\u5FAE\u4FE1\u7ED1\u5B9A\u5931\u8D25(".concat(res.data.msg, ")"));
          }
        });
      }
    });
    return function (_ctx, _cache) {
      var _unref$memberType, _managerInfo$value;
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_dialog = _resolveComponent("t-dialog");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_checkbox = _resolveComponent("t-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(navLeft)), _createElementVNode("div", _hoisted_2, [_cache[72] || (_cache[72] = _createElementVNode("div", {
        class: "account-body-top"
      }, "帐号信息", -1)), _createElementVNode("div", _hoisted_3, [_unref(accessInfo).accountType === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[57] || (_cache[57] = _createElementVNode("span", null, "昵称", -1)), _createElementVNode("div", null, _toDisplayString(nickname.value), 1)]), _createVNode(_component_t_button, {
        variant: "outline",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return nicknameVisible.value = true;
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[58] || (_cache[58] = [_createTextVNode("修改", -1)]));
        }),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[59] || (_cache[59] = _createElementVNode("span", null, "姓名", -1)), _createElementVNode("div", null, _toDisplayString(_unref(accessInfo).name), 1)])])), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[60] || (_cache[60] = _createElementVNode("span", null, "手机", -1)), _createElementVNode("div", null, _toDisplayString(phone.value), 1)]), _unref(accessInfo).accountType !== 0 && phone.value ? (_openBlock(), _createBlock(_component_t_button, {
        key: 0,
        variant: "outline",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return unbindPhoneShow.value = true;
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[61] || (_cache[61] = [_createTextVNode("解绑", -1)]));
        }),
        _: 1
      })) : _createCommentVNode("", true), _unref(accessInfo).accountType !== 0 ? (_openBlock(), _createBlock(_component_t_button, {
        key: 1,
        variant: "outline",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return openModal(1);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(phone.value ? '修改' : '新增'), 1)];
        }),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_cache[63] || (_cache[63] = _createElementVNode("span", null, "微信", -1)), _createElementVNode("div", null, [_unref(wechat) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[62] || (_cache[62] = _createElementVNode("span", null, "您已绑定微信,可以通过扫一扫登录慧学慧研", -1)), _createElementVNode("img", {
        src: _unref(userInfo).wxHeadimgurl,
        alt: ""
      }, null, 8, _hoisted_13), _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(userInfo).wxNickname), 1)])) : _createCommentVNode("", true)])]), _unref(accessInfo).accountType !== 0 ? (_openBlock(), _createBlock(_component_t_button, {
        key: 0,
        variant: "outline",
        onClick: toBindWechat
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref(wechat) ? '解除绑定' : '绑定'), 1)];
        }),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[64] || (_cache[64] = _createElementVNode("span", null, "邮箱", -1)), _createElementVNode("div", null, _toDisplayString(email.value), 1)]), _unref(accessInfo).accountType !== 0 ? (_openBlock(), _createBlock(_component_t_button, {
        key: 0,
        variant: "outline",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return openModal(2);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(email.value ? '修改' : '新增'), 1)];
        }),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[65] || (_cache[65] = _createElementVNode("span", null, "用户名", -1)), _createElementVNode("div", null, _toDisplayString(systemAutoUsernameFlag.value ? '' : username.value), 1)]), systemAutoUsernameFlag.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(accessInfo).accountType !== 0 ? (_openBlock(), _createBlock(_component_t_button, {
        key: 0,
        variant: "outline",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return openModal(3);
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[66] || (_cache[66] = [_createTextVNode("修改", -1)]));
        }),
        _: 1
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_cache[68] || (_cache[68] = _createElementVNode("div", {
        class: "account-body-center-li-left"
      }, [_createElementVNode("span", null, "密码"), _createElementVNode("div")], -1)), _createVNode(_component_t_button, {
        variant: "outline",
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return openModal(4);
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[67] || (_cache[67] = [_createTextVNode("修改", -1)]));
        }),
        _: 1
      })]), _unref(accessInfo).accountType !== 2 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_cache[69] || (_cache[69] = _createElementVNode("span", null, "到期日", -1)), _createElementVNode("div", null, _toDisplayString(_unref(accessInfo).serviceEndTime), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[70] || (_cache[70] = _createElementVNode("span", null, "帐号类型", -1)), _createElementVNode("div", null, _toDisplayString(_unref(accessInfo).accountType === 2 ? '个人帐号' : '') + " " + _toDisplayString(_unref(accessInfo).accountType === 1 ? '机构子帐号 ' + (_unref(userInfo).memberType ? (_unref$memberType = _unref(userInfo).memberType) === null || _unref$memberType === void 0 ? void 0 : _unref$memberType.map(function (item) {
        return memberTypesObj[item];
      }) : '') : '') + " " + _toDisplayString(_unref(accessInfo).accountType === 0 ? '超级管理员' : ''), 1)])]), _unref(accessInfo).accountType === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_t_button, {
        variant: "outline",
        theme: "danger",
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return cancellationVisible.value = true;
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[71] || (_cache[71] = [_createTextVNode("注销帐号", -1)]));
        }),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_25, [_createTextVNode(_toDisplayString(((_managerInfo$value = managerInfo.value) === null || _managerInfo$value === void 0 ? void 0 : _managerInfo$value.type) === -1 ? '如有帐号维护需求，请联系慧学慧研客户经理：' : '如需修改姓名，请联系学校/机构管理员：') + " ", 1), _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerInfo.value.managers, function (p) {
        return _openBlock(), _createElementBlock("div", {
          key: p.id
        }, [_createElementVNode("span", null, _toDisplayString(p.name) + "：", 1), _createElementVNode("span", null, _toDisplayString(p.phone || '无手机号'), 1)]);
      }), 128))])])])]), _createVNode(_component_t_dialog, {
        header: "微信绑定",
        visible: wxbindDialog.value,
        "onUpdate:visible": _cache[7] || (_cache[7] = function ($event) {
          return wxbindDialog.value = $event;
        }),
        cancelBtn: null,
        confirmBtn: null,
        onConfirm: handleOk
      }, {
        default: _withCtx(function () {
          return [wxbindDialog.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("iframe", {
            src: wxbindCodeUri.value,
            height: "400",
            sandbox: "allow-scripts allow-same-origin allow-top-navigation"
          }, null, 8, _hoisted_28)])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_t_dialog, {
        header: "修改昵称",
        visible: nicknameVisible.value,
        "onUpdate:visible": _cache[9] || (_cache[9] = function ($event) {
          return nicknameVisible.value = $event;
        }),
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        onClose: nicknameHandleCancel,
        onConfirm: handleOk
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_input, {
            value: nicknameOld.value,
            "onUpdate:value": _cache[8] || (_cache[8] = function ($event) {
              return nicknameOld.value = $event;
            }),
            maxlength: 20,
            placeholder: "请输入昵称"
          }, null, 8, ["value"])];
        }),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_t_dialog, {
        header: "Step3-设置新手机号",
        visible: phoneVisible.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = function ($event) {
          return phoneVisible.value = $event;
        }),
        cancelBtn: "上一步",
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        onCancel: _cache[14] || (_cache[14] = function ($event) {
          return openModalVisibles.value = true;
        }),
        onClose: phoneHandleCancel,
        onConfirm: handleOk
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("p", null, [_cache[73] || (_cache[73] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[74] || (_cache[74] = _createTextVNode("新手机号 ", -1)), _createVNode(_component_t_input, {
            value: phoneOld.value,
            "onUpdate:value": _cache[10] || (_cache[10] = function ($event) {
              return phoneOld.value = $event;
            }),
            onChange: handleInput,
            placeholder: "请输入新手机号"
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[75] || (_cache[75] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[76] || (_cache[76] = _createTextVNode("请输入验证码 ", -1)), _createVNode(_component_t_input, {
            value: passwordCode.value,
            "onUpdate:value": _cache[12] || (_cache[12] = function ($event) {
              return passwordCode.value = $event;
            }),
            placeholder: "请输入"
          }, {
            suffix: _withCtx(function () {
              return [sendOut.value === 0 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: {
                  "color": "#0f3fff",
                  "cursor": "pointer"
                },
                onClick: _cache[11] || (_cache[11] = function ($event) {
                  return sendOutCode(1);
                })
              }, "发送验证码")) : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(sendOut.value) + " s", 1))];
            }),
            _: 1
          }, 8, ["value"])])];
        }),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_t_dialog, {
        header: "Step3-设置新邮箱",
        visible: emailVisible.value,
        "onUpdate:visible": _cache[18] || (_cache[18] = function ($event) {
          return emailVisible.value = $event;
        }),
        cancelBtn: "上一步",
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        onCancel: _cache[19] || (_cache[19] = function ($event) {
          return openModalVisibles.value = true;
        }),
        onClose: emailHandleCancel,
        onConfirm: handleOk
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("p", null, [_cache[77] || (_cache[77] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[78] || (_cache[78] = _createTextVNode("新邮箱 ", -1)), _createVNode(_component_t_input, {
            value: emailOld.value,
            "onUpdate:value": _cache[15] || (_cache[15] = function ($event) {
              return emailOld.value = $event;
            }),
            placeholder: "请输入新邮箱"
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[79] || (_cache[79] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[80] || (_cache[80] = _createTextVNode("请输入验证码 ", -1)), _createVNode(_component_t_input, {
            value: passwordCode.value,
            "onUpdate:value": _cache[17] || (_cache[17] = function ($event) {
              return passwordCode.value = $event;
            }),
            placeholder: "请输入"
          }, {
            suffix: _withCtx(function () {
              return [sendOut.value === 0 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: {
                  "color": "#0f3fff",
                  "cursor": "pointer"
                },
                onClick: _cache[16] || (_cache[16] = function ($event) {
                  return sendOutCode(2);
                })
              }, "发送验证码")) : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(sendOut.value) + " s", 1))];
            }),
            _: 1
          }, 8, ["value"])])];
        }),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_t_dialog, {
        header: "Step3-设置用户名、密码",
        visible: usernameVisible.value,
        "onUpdate:visible": _cache[23] || (_cache[23] = function ($event) {
          return usernameVisible.value = $event;
        }),
        cancelBtn: "上一步",
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        onCancel: _cache[24] || (_cache[24] = function ($event) {
          return openModalVisibles.value = true;
        }),
        onClose: usernameHandleCancel,
        onConfirm: handleOk
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("p", null, [_cache[81] || (_cache[81] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[82] || (_cache[82] = _createTextVNode("新用户名 ", -1)), _createVNode(_component_t_input, {
            value: usernameOld.value,
            "onUpdate:value": _cache[20] || (_cache[20] = function ($event) {
              return usernameOld.value = $event;
            }),
            maxlength: 20,
            placeholder: "6-20个字符，支持英文字母、数字和下划线"
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[83] || (_cache[83] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[84] || (_cache[84] = _createTextVNode("密码 ", -1)), _createVNode(_component_t_input, {
            type: "password",
            value: password.value,
            "onUpdate:value": _cache[21] || (_cache[21] = function ($event) {
              return password.value = $event;
            }),
            maxlength: 16,
            placeholder: "8-16位含数字、大小写英文字母或特殊字符2种以上的组合"
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[85] || (_cache[85] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[86] || (_cache[86] = _createTextVNode("确认密码 ", -1)), _createVNode(_component_t_input, {
            type: "password",
            value: passwordOld.value,
            "onUpdate:value": _cache[22] || (_cache[22] = function ($event) {
              return passwordOld.value = $event;
            }),
            maxlength: 16,
            placeholder: "请再输入一次"
          }, null, 8, ["value"])])];
        }),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_t_dialog, {
        header: "Step3-设置新密码",
        visible: passwordVisible.value,
        "onUpdate:visible": _cache[27] || (_cache[27] = function ($event) {
          return passwordVisible.value = $event;
        }),
        cancelBtn: "上一步",
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        onCancel: _cache[28] || (_cache[28] = function ($event) {
          return openModalVisibles.value = true;
        }),
        onClose: passwordHandleCancel,
        onConfirm: handleOk
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("p", null, [_cache[87] || (_cache[87] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[88] || (_cache[88] = _createTextVNode("请输入新密码 ", -1)), _createVNode(_component_t_input, {
            type: "password",
            value: password.value,
            "onUpdate:value": _cache[25] || (_cache[25] = function ($event) {
              return password.value = $event;
            }),
            maxlength: 16,
            placeholder: "8-16位含数字、大小写英文字母或特殊字符2种以上的组合"
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[89] || (_cache[89] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[90] || (_cache[90] = _createTextVNode("再次输入密码 ", -1)), _createVNode(_component_t_input, {
            type: "password",
            value: passwordOld.value,
            "onUpdate:value": _cache[26] || (_cache[26] = function ($event) {
              return passwordOld.value = $event;
            }),
            maxlength: 16,
            placeholder: "请再输入一次"
          }, null, 8, ["value"])])];
        }),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_t_dialog, {
        header: "第一步",
        visible: stepOneVisible.value,
        "onUpdate:visible": _cache[30] || (_cache[30] = function ($event) {
          return stepOneVisible.value = $event;
        }),
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        onClose: stepOneHandleCancel,
        onConfirm: stepOneHandleOk
      }, {
        default: _withCtx(function () {
          return [_cache[92] || (_cache[92] = _createElementVNode("p", null, "给自己起一个好听的昵称吧", -1)), _createElementVNode("p", null, [_cache[91] || (_cache[91] = _createTextVNode(" 昵称 ", -1)), _createVNode(_component_t_input, {
            value: stepOnenickname.value,
            "onUpdate:value": _cache[29] || (_cache[29] = function ($event) {
              return stepOnenickname.value = $event;
            }),
            maxlength: 20,
            placeholder: "请输入内容"
          }, null, 8, ["value"])])];
        }),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_t_dialog, {
        header: "第二步",
        visible: stepTwoVisible.value,
        "onUpdate:visible": _cache[34] || (_cache[34] = function ($event) {
          return stepTwoVisible.value = $event;
        }),
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        onConfirm: stepTwoHandleOk
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("p", null, [_cache[93] || (_cache[93] = _createTextVNode(" 用户名 ", -1)), _createVNode(_component_t_input, {
            value: stepTwoUsername.value,
            "onUpdate:value": _cache[31] || (_cache[31] = function ($event) {
              return stepTwoUsername.value = $event;
            }),
            maxlength: 20,
            placeholder: "6-20个字符，支持英文字母、数字和下划线"
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[94] || (_cache[94] = _createTextVNode(" 密码 ", -1)), _createVNode(_component_t_input, {
            type: "password",
            value: stepTwoPassword.value,
            "onUpdate:value": _cache[32] || (_cache[32] = function ($event) {
              return stepTwoPassword.value = $event;
            }),
            maxlength: 16,
            placeholder: "8-16位含数字、大小写英文字母或特殊字符2种以上的组合"
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[95] || (_cache[95] = _createTextVNode(" 确认密码 ", -1)), _createVNode(_component_t_input, {
            type: "password",
            value: stepTwoPasswordOld.value,
            "onUpdate:value": _cache[33] || (_cache[33] = function ($event) {
              return stepTwoPasswordOld.value = $event;
            }),
            maxlength: 16,
            placeholder: "请再输入一次"
          }, null, 8, ["value"])])];
        }),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_t_dialog, {
        header: "Step1-选择验证方式",
        visible: openModalVisible.value,
        "onUpdate:visible": _cache[38] || (_cache[38] = function ($event) {
          return openModalVisible.value = $event;
        }),
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        footer: null
      }, {
        default: _withCtx(function () {
          return [_cache[96] || (_cache[96] = _createElementVNode("p", null, "请在下方选择一项进行身份验证！", -1)), _createElementVNode("p", {
            class: "p-btn",
            onClick: _cache[35] || (_cache[35] = function ($event) {
              return openModalClick(1);
            })
          }, "帐号+密码"), phone.value ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "p-btn",
            onClick: _cache[36] || (_cache[36] = function ($event) {
              return openModalClick(2);
            })
          }, "手机+验证码")) : _createCommentVNode("", true), email.value ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: "p-btn",
            onClick: _cache[37] || (_cache[37] = function ($event) {
              return openModalClick(3);
            })
          }, "邮箱+验证码")) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_t_dialog, {
        header: "Step2-身份验证",
        visible: openModalVisibles.value,
        "onUpdate:visible": _cache[47] || (_cache[47] = function ($event) {
          return openModalVisibles.value = $event;
        }),
        cancelBtn: "上一步",
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        onCancel: openModalCancel,
        onConfirm: openModalOk
      }, {
        default: _withCtx(function () {
          return [openModalIndexs.value === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("p", null, [_cache[97] || (_cache[97] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[98] || (_cache[98] = _createTextVNode("帐号 ", -1)), _createVNode(_component_t_input, {
            value: username.value,
            "onUpdate:value": _cache[39] || (_cache[39] = function ($event) {
              return username.value = $event;
            }),
            disabled: ""
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[99] || (_cache[99] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[100] || (_cache[100] = _createTextVNode("密码 ", -1)), _createVNode(_component_t_input, {
            type: "password",
            value: openModalPassword.value,
            "onUpdate:value": _cache[40] || (_cache[40] = function ($event) {
              return openModalPassword.value = $event;
            }),
            placeholder: "8-16位含数字、大小写英文字母或特殊字符2种以上的组合"
          }, null, 8, ["value"])])], 64)) : openModalIndexs.value === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("p", null, [_cache[101] || (_cache[101] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[102] || (_cache[102] = _createTextVNode("手机号 ", -1)), _createVNode(_component_t_input, {
            value: phone.value,
            "onUpdate:value": _cache[41] || (_cache[41] = function ($event) {
              return phone.value = $event;
            }),
            disabled: ""
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[103] || (_cache[103] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[104] || (_cache[104] = _createTextVNode("请输入验证码 ", -1)), _createVNode(_component_t_input, {
            value: openModalPassword.value,
            "onUpdate:value": _cache[43] || (_cache[43] = function ($event) {
              return openModalPassword.value = $event;
            }),
            placeholder: "请输入"
          }, {
            suffix: _withCtx(function () {
              return [sendOut.value === 0 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: {
                  "color": "#0f3fff",
                  "cursor": "pointer"
                },
                onClick: _cache[42] || (_cache[42] = function ($event) {
                  return sendOutCode(1);
                })
              }, "发送验证码")) : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(sendOut.value) + " s", 1))];
            }),
            _: 1
          }, 8, ["value"])])], 64)) : openModalIndexs.value === 3 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createElementVNode("p", null, [_cache[105] || (_cache[105] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[106] || (_cache[106] = _createTextVNode("邮箱 ", -1)), _createVNode(_component_t_input, {
            value: email.value,
            "onUpdate:value": _cache[44] || (_cache[44] = function ($event) {
              return email.value = $event;
            }),
            disabled: ""
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[107] || (_cache[107] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[108] || (_cache[108] = _createTextVNode("请输入验证码 ", -1)), _createVNode(_component_t_input, {
            value: openModalPassword.value,
            "onUpdate:value": _cache[46] || (_cache[46] = function ($event) {
              return openModalPassword.value = $event;
            }),
            placeholder: "请输入"
          }, {
            suffix: _withCtx(function () {
              return [sendOut.value === 0 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: {
                  "color": "#0f3fff",
                  "cursor": "pointer"
                },
                onClick: _cache[45] || (_cache[45] = function ($event) {
                  return sendOutCode(2);
                })
              }, "发送验证码")) : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(sendOut.value) + " s", 1))];
            }),
            _: 1
          }, 8, ["value"])])], 64)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_t_dialog, {
        header: cancellationArr[cancellationIndex.value],
        visible: cancellationVisible.value,
        "onUpdate:visible": _cache[54] || (_cache[54] = function ($event) {
          return cancellationVisible.value = $event;
        }),
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        footer: null,
        width: cancellationStyle.value,
        onClosed: afterClose
      }, _createSlots({
        default: _withCtx(function () {
          return [cancellationIndex.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toConsumableArray(_cache[109] || (_cache[109] = [_createElementVNode("div", null, "发布日期：2023年9月1日", -1), _createElementVNode("div", null, "生效日期：2023年9月4日", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", {
            style: {
              "font-weight": "bold"
            }
          }, "【注销前的特别提示】", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, " 尊敬的用户，在您正式开始慧学慧研帐号注销流程前，请充分阅读并理解《慧学慧研帐号注销协议》（“本协议”）。 我们特别提请您注意：注销本慧学慧研帐号后，除法律法规另有规定外，您在本慧学慧研帐号下的个人信息将被删除或匿名化处理； 且注销前您使用本慧学慧研帐号已关联的智学慧教（湖北）教育科技有限公司及其关联公司（以下简称“我们”或者“慧学慧研”）或第三方的相关产品与服务（“关联产品与服务”）将不再关联， 您可能因此无法使用关联产品与服务，或者给您后续使用关联产品与服务或售后维权等带来不便。本慧学慧研帐号一旦注销完成，将无法恢复。即使您使用相同的登录方式作为慧学慧研帐号再次注册并使用慧学慧研， 您亦将无法再使用本慧学慧研帐号或找回您添加或绑定的任何内容或信息，请您谨慎操作。 ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, " 若您经过慎重考虑后仍决定注销本慧学慧研帐号，您需要首先同意本协议全部内容，并请您点击确认并按照我们的注销操作流程开始进行下一步操作， 您的相关操作将视为您已经同意和遵守本协议全部内容。我们善意提醒您，在申请注销前请对需要备份的内容提前做好备份。 ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, "如您在注销后需要再次使用慧学慧研服务的，欢迎您重新注册慧学慧研帐号。", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, " 同时，我们非常欢迎您对我们的产品/服务提出宝贵意见或建议，您可以通过客服或发邮件至zxhj@zhixuehuijiao.cn的方式反馈给我们， 以便我们进一步了解您的愿望和需求，感谢您的协助和支持。 ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, "如您仍决定注销慧学慧研帐号的，请务必仔细阅读下述条款，并确认进行下一步操作。", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, " 一、您知悉并同意：在您的慧学慧研帐号注销后，将（可能）产生包括但不限于如下结果，并需要您自行承担： 您将无法登录、使用本慧学慧研帐号，包括但不限于： 其他用户无法与您在慧学慧研内进行互动，包括但不限于评论、点赞等； 如您曾使用本慧学慧研帐号登录慧学慧研多个终端产品，则您的帐号在该多个终端产品上一并注销，且相关个人信息和权益也一并被删除或匿名化处理。包括但不限于： ", -1), _createElementVNode("div", null, " 安卓客户端； IOS客户端； IPad客户端； aPad客户端； Web官网； Mac客户端； 手机H5网页； PC客户端； 微信小程序。 ", -1), _createElementVNode("div", null, " 如您曾使用本慧学慧研帐号在慧学慧研合作的互联网产品（“合作产品”）中登录慧学慧研网站、APP或慧学慧研其他服务，则本慧学慧研帐号注销后 您将无法在上述合作产品中通过本慧学慧研帐号使用慧学慧研服务，且相关个人信息和权益也一并被删除或匿名化处理。合作产品（根据慧学慧研的实际合作范围调整）。 ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, " 除法律法规另有规定外，您于本慧学慧研帐号下的个人信息将会被删除或匿名化处理。您无法再找回您的个人信息，也无权要求我们找回，前述个人信息包括但不限于： ", -1), _createElementVNode("div", null, " 头像、昵称、绑定的邮箱、手机号码等个人资料信息、设备信息、生日信息、关联帐号信息、个性化设置与功能等； ", -1), _createElementVNode("div", null, " 评论点赞、上传视频信息、下载并存储于慧学慧研服务器的信息、收藏、观看记录、浏览记录等；第三方关联数据相关信息等； ", -1), _createElementVNode("div", null, "与本慧学慧研帐号相关的其他信息。", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, " 您同意，一旦您同意本协议或您注销本慧学慧研帐号，即视为您放弃该慧学慧研帐号在本慧学慧研使用期间已产生的及未来可能产生的慧学慧研权益， 因此产生的后果由您自行承担，我们有权对该慧学慧研帐号下的全部慧学慧研权益做清除处理，且您放弃向我们主张未消耗的权益。该等慧学慧研权益包括但不限于： ", -1), _createElementVNode("div", null, "与慧学慧研帐号等级成长升级相关的所有数据（包括但不限于经验值、称号、等级、身份标识等）；", -1), _createElementVNode("div", null, "其他已产生但未消耗完毕的其他慧学慧研权益或未来预期的慧学慧研权益等。", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, " 本慧学慧研帐号一旦注销，将无法恢复。即使您在注销后以相同的登录方式作为慧学慧研帐号再次向我们申请注册慧学慧研帐号的，此时该帐号将视为新的用户帐号。 因此，我们善意地提醒您在申请注销前对需要备份的内容提前做好备份。同时，也建议您在申请注销前清除系统缓存。 ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, " 本慧学慧研帐号一旦注销成功，您与我们曾签署过的慧学慧研相关协议，包括但不限于《慧学慧研用户协议》、其他权利义务性文件（统称“相关协议”）等相应终止（但根据相关协议约定或根据条款性质应继续有效的条款或法律法规另有规定的除外）。 但相关协议终止并不影响慧学慧研帐号注销前您通过本慧学慧研帐号使用慧学慧研服务应当承担的相关责任，您仍需要对慧学慧研帐号注销前的使用行为承担相应责任，包括但不限于可能产生的违约责任、损害赔偿责任及履约义务等；其他因本慧学慧研帐号注销（可能）产生的后果。 ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, " 二、在您向我们申请注销慧学慧研帐号之前，为保障您的帐号安全和相关权益，您需先行检查与确保您申请注销的慧学慧研帐号已经同时满足以下条件，这些条件包括但不限于： ", -1), _createElementVNode("div", null, "您的帐号为本人合法拥有，且符合用户协议及相关说明规则中有关慧学慧研帐号的规定；", -1), _createElementVNode("div", null, "您的帐号为正常使用中且无违规、被封、被盗等情形；", -1), _createElementVNode("div", null, "您的帐号无任何纠纷：包括投诉举报、被投诉举报、国家机关调查、仲裁、诉讼等纠纷；", -1), _createElementVNode("div", null, "您的帐号无任何未消耗的虚拟资产：如资源等；", -1), _createElementVNode("div", null, " 上述问题您可首先尝试自行处理，如您无法处理的或在处理过程中有任何疑惑的，可联系慧学慧研客服协助处理。 ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, "三、注销流程", -1), _createElementVNode("div", null, "您需按照我们的官方渠道提供的注销流程和操作指引，在相关功能设置页面进行注销操作；", -1), _createElementVNode("div", null, "您已经同意本协议的全部内容；同时，您已经检查与确认满足了本协议第二条的要求；", -1), _createElementVNode("div", null, " 在您完成上述第2点后，为保障您的帐号安全和财产权益，我们有权进行注销申请的身份验证以判断您是本慧学慧研帐号的有权使用人（如由您提供操作相关信息供我们核实等）。如我们在综合判断后发现本慧学慧研帐号不符合注销条件，或者身份验证失败的，您的注销可能会失败， 您可以按照我们的指引进行后续操作或联系客服协助处理。我们判断您符合注销条件仅仅是基于您的承诺（即您自身确保本慧学慧研帐号符合上述注销条件的承诺）进行的形式审查，仍由您自身对慧学慧研帐号符合上述注销条件承担责任，我们对此不承担法律责任； ", -1), _createElementVNode("div", null, " 在您成功完成上述第3点的“身份验证”后，我们将会在30天内处理注销申请，注销成功后，本慧学慧研帐号项下的所有个人信息或权益资产等都将被删除或匿名化处理。 ", -1), _createElementVNode("div", null, " 具体的注销流程和操作以慧学慧研官方公布的为准。您理解并同意，在您申请注销帐号期间，如我们需要对相关信息、投诉或其他与本慧学慧研帐号相关的事项进行核实的，或者有其他合理理由的，我们有权冻结本慧学慧研帐号且暂时不为您提供注销服务。 ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, "四、其他", -1), _createElementVNode("div", null, " 请您了解，本协议为《慧学慧研用户协议》、《慧学慧研隐私政策》的补充协议，是其不可分割的组成部分，与其构成统一整体。本协议与上述内容存在冲突的，以本协议为准。 同时，您知悉并同意：即使本慧学慧研帐号被注销，也并不减轻或免除您应根据相关法律法规、相关协议、规则等（可能）需要承担的相关责任。 ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", null, " 如在帐号注销过程中有任何问题您无法处理，或在处理过程中有任何疑惑的，可联系客服协助处理，您也可以将您的问题发送至zxhj@zhixuehuijiao.cn，我们将尽快审核所涉问题，并在验证您的用户身份后予以回复。 ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("div", {
            style: {
              "text-align": "right"
            }
          }, "智学慧教（湖北）教育科技有限公司", -1), _createElementVNode("br", null, null, -1)])))) : cancellationIndex.value === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_cache[110] || (_cache[110] = _createElementVNode("p", null, "您的帐号不能注销", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cancellationList.value, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              style: {
                "display": "flex"
              },
              key: index
            }, [_createElementVNode("span", _hoisted_34, _toDisplayString(item.reason), 1), item.flag ? (_openBlock(), _createElementBlock("span", _hoisted_35, "验证通过")) : (_openBlock(), _createElementBlock("span", _hoisted_36, "验证失败"))]);
          }), 128))], 64)) : cancellationIndex.value === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_cache[113] || (_cache[113] = _createElementVNode("div", {
            style: {
              "padding": "20px 0"
            }
          }, "注销帐号会清空所有信息和数据且不能恢复，您确认要注销吗？", -1)), _createElementVNode("div", _hoisted_37, [_createVNode(_component_t_button, {
            variant: "outline",
            theme: "danger",
            onClick: _cache[48] || (_cache[48] = function ($event) {
              return cancellationIndex.value = 3;
            })
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[111] || (_cache[111] = [_createTextVNode("确认注销", -1)]));
            }),
            _: 1
          }), _createVNode(_component_t_button, {
            style: {
              "margin-left": "16px"
            },
            onClick: _cache[49] || (_cache[49] = function ($event) {
              return cancellationVisible.value = false;
            })
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[112] || (_cache[112] = [_createTextVNode("我再想想", -1)]));
            }),
            _: 1
          })])], 64)) : cancellationIndex.value === 3 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 3
          }, [_createElementVNode("p", null, [_cache[114] || (_cache[114] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[115] || (_cache[115] = _createTextVNode("手机号 ", -1)), _createVNode(_component_t_input, {
            value: phone.value,
            "onUpdate:value": _cache[50] || (_cache[50] = function ($event) {
              return phone.value = $event;
            }),
            disabled: ""
          }, null, 8, ["value"])]), _createElementVNode("p", null, [_cache[116] || (_cache[116] = _createElementVNode("span", {
            class: "red"
          }, "* ", -1)), _cache[117] || (_cache[117] = _createTextVNode("请输入验证码 ", -1)), _createVNode(_component_t_input, {
            value: cancellationPassword.value,
            "onUpdate:value": _cache[52] || (_cache[52] = function ($event) {
              return cancellationPassword.value = $event;
            }),
            placeholder: "请输入"
          }, {
            suffix: _withCtx(function () {
              return [sendOut.value === 0 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: {
                  "color": "#0f3fff",
                  "cursor": "pointer"
                },
                onClick: _cache[51] || (_cache[51] = function ($event) {
                  return sendOutCode(3);
                })
              }, "发送验证码")) : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(sendOut.value) + " s", 1))];
            }),
            _: 1
          }, 8, ["value"])]), _createElementVNode("div", _hoisted_39, [_createVNode(_component_t_button, {
            style: {
              "margin-left": "16px"
            },
            onClick: cancellationOk
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[118] || (_cache[118] = [_createTextVNode("确定", -1)]));
            }),
            _: 1
          })])], 64)) : cancellationIndex.value === 4 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 4
          }, [_cache[121] || (_cache[121] = _createElementVNode("div", {
            style: {
              "padding": "20px 0"
            }
          }, " 您的帐号已申请注销，申请30天后会自动注销，期间如果想取消注销，可以随时登录网站操作。 ", -1)), _createElementVNode("div", _hoisted_40, [_createVNode(_component_t_button, {
            ghost: "",
            onClick: cancellationOkLogin
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[119] || (_cache[119] = [_createTextVNode("确认", -1)]));
            }),
            _: 1
          }), _createVNode(_component_t_button, {
            style: {
              "margin-left": "16px"
            },
            onClick: cancellationRevoke
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[120] || (_cache[120] = [_createTextVNode("撤销注销申请", -1)]));
            }),
            _: 1
          })])], 64)) : _createCommentVNode("", true)];
        }),
        _: 2
      }, [cancellationIndex.value === 0 ? {
        name: "footer",
        fn: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_41, [_createVNode(_component_t_checkbox, {
            checked: cancellationChecked.value,
            "onUpdate:checked": _cache[53] || (_cache[53] = function ($event) {
              return cancellationChecked.value = $event;
            })
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[122] || (_cache[122] = [_createTextVNode(" 我已阅读并接受慧学慧研全部注销协议 ", -1)]));
            }),
            _: 1
          }, 8, ["checked"]), _createVNode(_component_t_button, {
            onClick: cancellationStep1
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[123] || (_cache[123] = [_createTextVNode("下一步", -1)]));
            }),
            _: 1
          })])];
        }),
        key: "0"
      } : undefined]), 1032, ["header", "visible", "width"]), _createVNode(unbindPhoneDialog, {
        modelValue: unbindPhoneShow.value,
        "onUpdate:modelValue": _cache[55] || (_cache[55] = function ($event) {
          return unbindPhoneShow.value = $event;
        }),
        onReload: _cache[56] || (_cache[56] = function ($event) {
          return phone.value = '';
        })
      }, null, 8, ["modelValue"])]);
    };
  }
};